import { TaxonomyType } from 'src/types'

export const getTaxonomyQueryFieldName = (title: TaxonomyType | string) => {
  if (title === TaxonomyType.Audience) return 'audiences'
  else if (title === TaxonomyType.PracticeArea) return 'practiceAreas'
  else if (title === TaxonomyType.Language) return 'languages'
  else if (title === TaxonomyType.Deployment) return 'deployments'
  else if (title === TaxonomyType.Attribute) return 'attributes'
  else if (title === TaxonomyType.EventFeature) return 'eventFeature'
  else if (title === TaxonomyType.RegionsServed) return 'regionsServed'
  else if (title === TaxonomyType.Format) return 'formats'
  else if (title === TaxonomyType.Duration) return 'durations'
  else if (title === TaxonomyType.Location) return 'locations'
  else if (title === TaxonomyType.Organization) return 'organizations'
  else if (title === TaxonomyType.ResourceType) return 'resourceType'
  else if (title === TaxonomyType.Topic) return 'topics'
  else if (title === TaxonomyType.ProductType) return 'productType'
  else if (title === TaxonomyType.HQ) return 'hqs'
  else if (title === TaxonomyType.ContentType) return 'contentType'
  else if (title === TaxonomyType.SubjectMatter) return 'subjectMatter'
  else if (title === TaxonomyType.Phase) return 'phase'
  else if (title === TaxonomyType.Theme) return 'theme'
  else if (title === TaxonomyType.DocumentType) return 'documentType'
  else if (title === TaxonomyType.Author) return 'author'
  else if (title === TaxonomyType.Date) return 'date'
  else if (title === TaxonomyType.StartDate) return 'startDate'
  else if (title === TaxonomyType.EndDate) return 'endDate'
  else if (title === TaxonomyType.Subject) return 'subject'
  else if (title === TaxonomyType.SponsorLevel) return 'sponsorLevels'
  else if (title === TaxonomyType.vendorTopic) return 'vendorTopic'
  return null
}
